<template>
    <div class="ssssss">
		<header>
			<h1>
				<router-link to="/mine">
					<v-icon name="chevron-left" class="set_2"></v-icon>
				</router-link>
				<p class="set_1">播放记录</p>
			</h1>
		</header>

		<!-- 订单 -->

			
			<div class="dd_cntx" v-for="item in datas">
				<div class="dd_cntxa">
					<img :src="'http://ts.winwulian.com/uploads/booklistphoto'+'/'+item.b_pic" class="dd_cntxaimg">
					<button class="shoubut" v-on:click="del(item.pl_id)">删除</button>
					<p class="dd_cntxap shouye_dianxxx" id="dd_cntxaf">{{item.bp_title}}</p>
					<p class="dd_cntxap" id="dd_cntxafa">专辑名:<span>{{item.b_bookname}}</span></p>
					<p class="dd_cntxap" id="dd_cntxapl">
					<v-icon name="clock" class="clock"></v-icon>
					<span>{{item.bp_timelength}}</span>
					</p>
					<button class="kkkxxx" @click="hrefs(item.b_is_video,item.b_id,item.bp_id,item.bp_price)">播放</button>
				</div>
			</div>


		
		<!-- 订单end -->
		<p class="dd_indexend">已显示全部</p>
		<div class="tc_nav">
	        <span class="tc_navx"></span>
	    </div>
    </div>
    
</template>
<script>
import $ from 'jquery';
import { CURL } from "../../lib/url.js";
export default {
	inject:['reload'],
	data() {
	  return {
	    params: '',
	    datas:[]
	  }
	},
	created(){
      var openid=localStorage.getItem("openid");
      this.openid = openid;
   },
	mounted(){
		this.getAjax();
	},
	methods:{
		hrefs (b_is_video,book_id,bp_id,bp_price) {
			var openid=localStorage.getItem("openid");
			if(b_is_video == 2){
				var successCallback =  (msg) => {
       			if(bp_price == '0.00'){
//	       			location.href = '/discover/discont/mmm/'+[book_id,bp_id];
	       			this.$router.push({path:'/discover/discont/mmm/'+[book_id,bp_id]})
       			}else{
	       			if(msg.status == 1 || msg.status == 2){
//	                	location.href = '/discover/discont/mmm/'+[book_id,bp_id];
	                	this.$router.push({path:'/discover/discont/mmm/'+[book_id,bp_id]})
	                }else{
//	                	location.href = '/discover/pay/'+[book_id,bp_id,bp_price];
	                	this.$router.push({path:'/discover/pay/'+[book_id,bp_id,bp_price]})
	                }		
       			}
            }
       		var errorCallback =  (msg) => {
                  console.log('error')
            }
       		this.$http.get(CURL+'/portal/All/getzjorder?bp_id='+bp_id+'&openid='+openid,{
              	data:{}
              }).then(successCallback,errorCallback);
				// volume-up 音频
			}else{
				var successCallback =  (response) => {
				var sp = 1
				if(response.status == 2 || response.status == 1 || bp_price == '0.00'){
//					location.href = '/video/playm/'+[book_id,bp_id]
					this.$router.push({path:'/video/playm/'+[book_id,bp_id]})
				}else{
//					location.href = '/discover/pay/'+[book_id,bp_id,bp_price,sp];
					this.$router.push({path:'/discover/pay/'+[book_id,bp_id,bp_price,sp]})
				}

				}
				var errorCallback =  (response) => {
					console.log('errorCallback')
				}
				this.$http.get(CURL+'/portal/All/getzjorder?book_id='+book_id+'&bp_id='+bp_id+'&openid='+openid,{
				data:{}
				}).then(successCallback,errorCallback);
				// tv 视频
			}
		},
	    getAjax:function () {
	     var successCallback =  (response) => {
	        console.log(response.data)
	        if(response){
	          this.datas = response.data
	        }
	      }
	      var errorCallback =  (response) => {
	          console.log('服务器请求出错了')
	      }
	      this.$http.get(CURL+'/portal/all/getplaylogs?openid='+this.openid,{
	        data:{}
	      }).then(successCallback,errorCallback);
	    },
	    del:function(id){
	    	  var openid=localStorage.getItem("openid")
	    	  var successCallback =  (response) => {
		        // console.log(response)
		        if(response.status==200){
		            $('.tc_navx').text(response.msg)
		            $('.tc_nav').fadeIn()
		            setTimeout(function(){
		                $('.tc_nav').fadeOut()
		                window.location.reload()
		            },2000)
		        }else{
		        	$('.tc_navx').text(response.msg)
		            $('.tc_nav').fadeIn()
		            setTimeout(function(){
		                $('.tc_nav').fadeOut()
		            },2000)
		        }
		        this.reload();			      	
		      }
		      var errorCallback =  (response) => {
		          console.log('服务器请求出错了')
		      }
		      this.$http.get(CURL+'/portal/all/getdeleplaylogs?pl_id='+id,{
		        data:{}
		      }).then(successCallback,errorCallback);
    	}
  	}
}

</script>
<style lang="scss" scoped>
.kkkxxx{
padding: 2px 11px 2px 11px;
border: #00a8d9 solid 1px;
color: #00a8d9;
background-color: inherit;
border-radius: 15px;
float: right;
margin: 10px 10px 10px 0;
}
.tc_navx{
    background-color: #00a8d9;
    border-radius: 5px;
    padding: 10px 20px 10px 20px;
}
.tc_nav{
    display: none;
    position: fixed;
    margin-left: 20%;
    text-align: center;
    width: 60%;
/*  height: 30px;*/
    color: #ffffff;
    font-size: 15px;
    bottom: 70%;
}
.ssssss{
	background-color: #FFFFFF;
}
.clock{
	width: 12px;
	padding-top: 4px;
}
.shoubut{
	background-color: inherit;
	float: right;
	width: 13%;
	margin-right: 10px;
	margin-top: 10px;
	font-size: 12px;
	color: #777;
}
/*end*/

.dd_indexend{
	width: 100%;
	float: left;
	margin-top: 50px;
	text-align: center;
	font-size: 15px;
	color: #777;
}
/*cont*/
#dd_cntxafa{
	font-size: 13px;
	margin: 5px 0 6px 0;
	padding-left: 10px;
	color: #777;
}
#dd_cntxaf{
	font-size: 16px;
	padding-left: 10px;
}

#dd_cntxapl{
	margin-top: 0;
	font-size: 13px;
	color: #999;
	padding-left: 10px;
}
.dd_cntxap{
	margin-top: 10px;
	width: 60%;
	float: left;
}
.dd_cntxaimg{
	margin: 5px 0 5px 5px;
	width: 16%;
	float: left;
	height: 85px;
}
.dd_ddh{
	height: 50px;
	line-height: 50px;
	padding-left: 15px;
	color: #777;
}
.dd_cntxa{
	width: 94%;
	background-color: #fafafa;
	float: left;
	margin-left: 3%;
	margin-right: 3%;
}
.dd_cntx{
	float: left;
	width: 100%;
	margin-top: 15px;
}
/*but*/
.dd_but{
	width: 49.5%;
	border-right: #eee solid 1px;
	background-color: #FFFFFF;
	color: #00a8d9;
}
.dd_buta{
	width: 49.5%;
	background-color: #FFFFFF;
}
.dd_buti{
	float: left;
	width: 100%;
	background-color: #FFFFFF;
	height: 45px;
	line-height: 45px;
	border-bottom: #eee solid 2px;
}
/*head*/
header{
  height: .4rem;
  background:url(../../img/ss.png);
  background-size:100% 100%;
  background-repeat: no-repeat;
  float: left;
  width: 100%;
  h1{
    margin-top: .2rem;
  }
}
.set_1{
	text-align: center;
    float: left;
    width: 88%;
    font-weight: 600;
    color: #FFFFFF;
    font-size: 19px;
    line-height:0;
}
.set_2{
	float: left;
	margin-top: -7px;
	margin-left: 3%;
	width: 5%;
	color: #FFFFFF;
}
/**/
.shouye_dianxxx{
  overflow: hidden;
  white-space:nowrap;
  -webkit-text-overflow:ellipsis;
  -moz-text-overflow:ellipsis;
  -o-text-overflow:ellipsis;
  -ms-text-overflow:ellipsis;
  text-overflow:ellipsis;
}
</style>


// WEBPACK FOOTER //
// src/components/mine/bofang.vue